import React, { useState } from "react";
import axios from "axios";
// import { get, post } from "../../utility/fetchConnectedWeb";
import notification from "../../utility/notification";
import EdsgLogo from "../../assets/images/ConnectHealthPro.png";


const PasswordReset = ({ onClose }) => {
  const [step, setStep] = useState(1); // State to manage the current step
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const [passwordChecks, setPasswordChecks] = useState([
    { label: "At least 8 characters", valid: false },
    { label: "One uppercase letter", valid: false },
    { label: "One lowercase letter", valid: false },
    { label: "One number", valid: false },
    { label: "One special character", valid: false },
  ]);

  // Update password checks on password change
  const handlePasswordChange = (value) => {
    setNewPassword(value);
    console.log("value", value);
    setPasswordChecks([
      { label: "At least 8 characters", valid: value.length >= 8 },
      { label: "One uppercase letter", valid: /[A-Z]/.test(value) },
      { label: "One lowercase letter", valid: /[a-z]/.test(value) },
      { label: "One number", valid: /\d/.test(value) },
      {
        label: "One special character",
        valid: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(value),
      },
    ]);
  };

  const handleNext = async () => {
    if (step === 1) {
      if (!email || !/\S+@\S+\.\S+/.test(email)) {
        setError("Please enter a valid email address.");
        return;
      }
      setLoading(true);
      setError("");
      try {
        const res = await axios.post(
          `https://api.greenzonetechnologies.com.ng/ConnectedHealthWebApi/api/Auth/generate-otp?email=${encodeURIComponent(
            email
          )}`
        );
        setStep(2);
      } catch (err) {
        setError("Failed to send OTP. Please try again.");
      }
      setLoading(false);
    } else if (step === 2) {
      const otpValue = otp.join("");
      if (otpValue.length !== 4) {
        setError("Please enter the 4-digit OTP.");
        return;
      }
      setLoading(true);
      setError("");
      try {
        const res = await axios.get(
          `https://api.greenzonetechnologies.com.ng/ConnectedHealthWebApi/api/Patient/Validateotp?otp=${encodeURIComponent(
            otpValue
          )}&email=${encodeURIComponent(email)}`
        );
        if (res) {
          console.log(res.data);
          setStep(3);
        } else {
          setError(res.data?.message || "Invalid OTP. Please try again.");
        }
      } catch (err) {
        setError("Failed to validate OTP. Please try again.");
      }
      setLoading(false);
    } else if (step === 3) {
      // Password validation
      const passwordRegex =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,}$/;
      if (!newPassword) {
        setPasswordError("Password is required.");
        return;
      }
      if (!passwordRegex.test(newPassword)) {
        setPasswordError(
          "Password must be at least 8 characters, include uppercase, lowercase, number, and special character."
        );
        return;
      }
      if (newPassword !== confirmPassword) {
        setPasswordError("Passwords do not match.");
        console.log("Passwords do not match.");
        return;
      }
      setPasswordError("");
      // Proceed with password reset API call here if needed
      alert("Password reset successful!");
    } else if (step < 3) {
      setStep(step + 1);
    }
  };

  const handleBack = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  const resetPasswords = async (e) => {
    if (e) e.preventDefault();
    const payload = {
      email,
      otp: otp.join(""),
      password: newPassword,
      confirmPassword,
    };
    try {
      const url = `https://api.greenzonetechnologies.com.ng/ConnectedHealthWebApi/api/Auth/forgot-password`;
      const response = await axios.post(url, payload);
      console.log(response.data);

      if (response.data.status == "success") {
        notification({
          title: "Success",
          message: response.data.message || "Password reset successful!",
          type: "success",
        });
        if (onClose) onClose();
      }
      // Handle success (show message, redirect, etc.)
    } catch (error) {
      notification({
        title: "Error",
        message: "Failed to reset password. Please try again.",
        type: "danger",
      });

      console.error("Error resetting password:", error);
    }
  };

  // Inline SVG for the close icon (X)
  const CloseIcon = ({ className }) => (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 384 512"
      fill="currentColor"
    >
      <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
    </svg>
  );

  return (
    <div className="password-reset-container">
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

          // body {
          //   font-family: 'Inter', sans-serif;
          //   background-color: #f0f2f5;
          //   display: flex;
          //   justify-content: center;
          //   align-items: center;
          //   min-height: 100vh;
          //   margin: 0;
          //   padding: 20px;
          //   box-sizing: border-box;
          // }

          .password-reset-container {
            background-color: #ffffff;
            border-radius: 12px;
            // box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
            width: 100%;
            max-width: 500px;
            padding: 30px;
            box-sizing: border-box;
            position: relative;
          }

          .close-icon {
            position: absolute;
            top: 20px;
            right: 20px;
            font-size: 24px;
            color: #888;
            cursor: pointer;
            width: 20px; /* Adjust SVG size */
            height: 20px;
          }

          .header-logo {
            display: flex;
            justify-content: center;
            margin-bottom: 25px;
          }

          .logo-text {
            font-size: 24px;
            font-weight: 700;
            color: #28a745; /* Green color from the image */
            display: flex;
            align-items: center;
            gap: 5px;
          }

          .logo-box {
            border: 2px solid #28a745;
            padding: 2px 5px;
            border-radius: 4px;
            font-size: 18px;
            font-weight: 700;
          }

          h1 {
            font-size: 26px;
            color: #28a745;
            text-align: center;
            margin-bottom: 10px;
            font-weight: 600;
          }

          p {
            font-size: 15px;
            color: #666;
            text-align: center;
            margin-bottom: 30px;
          }

          .steps-indicator {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 30px;
            position: relative;
          }

          // .steps-indicator::before {
          //   content: '';
          //   position: absolute;
          //   top: 50%;
          //   left: 0;
          //   right: 0;
          //   height: 2px;
          //   background-color: #e0e0e0;
          //   transform: translateY(-70%);
          //   z-index: 0;
          // }

          .step-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            flex: 1;
            position: relative;
            z-index: 1;
          }

          .step-circle {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: 600;
            font-size: 14px;
            margin-bottom: 8px;
            transition: background-color 0.3s, color 0.3s;
          }

          .step-circle.active {
            background-color: #28a745;
            color: white;
          }

          .step-circle.inactive {
            background-color: #e0e0e0;
            color: #888;
          }

          .step-label {
            font-size: 14px;
            font-weight: 500;
            color: #888;
            text-align: center;
            transition: color 0.3s;
          }

          .step-item.active .step-label {
            color: #333;
          }

          .input-group {
            margin-bottom: 5px;
          }

          .input-group label {
            display: block;
            font-size: 14px;
            color: #555;
            margin-bottom: 8px;
            font-weight: 500;
          }

          .input-group input {
            width: 100%;
            padding: 12px 15px;
            border: 1px solid #ddd;
            border-radius: 8px;
            font-size: 16px;
            box-sizing: border-box;
            transition: border-color 0.2s, box-shadow 0.2s;
          }

          .input-group input:focus {
            outline: none;
            border-color: #28a745;
            box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.2);
          }

          .next-button {
            background-color: #28a745;
            color: white;
            border: none;
            border-radius: 8px;
            padding: 14px 25px;
            font-size: 17px;
            font-weight: 600;
            cursor: pointer;
            width: auto; /* Adjust width as needed */
            display: block; /* To center with margin auto */
            margin-left: auto; /* Align to right */
            transition: background-color 0.3s ease, transform 0.1s ease;
          }

          .next-button:hover {
            background-color: #218838;
            transform: translateY(-1px);
          }

          .next-button:active {
            transform: translateY(0);
          }

          /* Content for each step */
          .step-content {
            padding-top: 20px;
          }

          .otp-input-group {
            display: flex;
            justify-content: center;
            gap: 10px;
            margin-bottom: 25px;
          }

          .otp-input-group input {
            width: 50px;
            height: 50px;
            text-align: center;
            font-size: 24px;
            border: 1px solid #ddd;
            border-radius: 8px;
          }

          .otp-input-group input:focus {
            outline: none;
            border-color: #28a745;
            box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.2);
          }

          .reset-password-fields {
            display: flex;
            flex-direction: column;
            gap: 20px;
          }

          /* Responsive adjustments */
          @media (max-width: 600px) {
            .password-reset-container {
              border-radius: 0;
              box-shadow: none;
              padding: 20px;
            }
            body {
              padding: 0;
            }
            .steps-indicator {
              flex-direction: column;
              align-items: flex-start;
            }
            .step-item {
              flex-direction: row;
              align-items: center;
              margin-bottom: 15px;
            }
            .step-circle {
              margin-bottom: 0;
              margin-right: 10px;
            }
            .steps-indicator::before {
              width: 2px;
              height: calc(100% - 60px); /* Adjust line height */
              top: 30px; /* Start line below first circle */
              left: 15px; /* Align with circle center */
            }
          }
        `}
      </style>

      {/* <CloseIcon className="close-icon" /> */}

      <div className="header-logo">
        <div className="logo-text">
          <img style={{height:'80px', width:'100%'}} src={EdsgLogo} alt="ConnectHealthPro Logo" />
        </div>
      </div>

      <h1>Reset Your Password</h1>
      <p>Please follow the steps to reset your password securely</p>

      <div className="steps-indicator">
        <div className={`step-item ${step === 1 ? "active" : "inactive"}`}>
          <div className={`step-circle ${step === 1 ? "active" : "inactive"}`}>
            1
          </div>
          <span className="step-label">Enter Email</span>
        </div>
        <div className={`step-item ${step === 2 ? "active" : "inactive"}`}>
          <div className={`step-circle ${step === 2 ? "active" : "inactive"}`}>
            2
          </div>
          <span className="step-label">Verify OTP</span>
        </div>
        <div className={`step-item ${step === 3 ? "active" : "inactive"}`}>
          <div className={`step-circle ${step === 3 ? "active" : "inactive"}`}>
            3
          </div>
          <span className="step-label">Reset Password</span>
        </div>
      </div>

      <div className="step-content">
        {step === 1 && (
          <div className="input-group">
            <label htmlFor="email">Email Address *</label>
            <input
              type="email"
              id="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
            />
            {error && (
              <div style={{ color: "red", marginBottom: "10px" }}>{error}</div>
            )}
            <button
              className="next-button"
              onClick={handleNext}
              disabled={loading}
              style={{marginTop:'20px'}}
            >
              {loading ? "Sending..." : "NEXT"}
            </button>
          </div>
        )}

        {step === 2 && (
          <div>
            <p
              style={{ textAlign: "left", marginBottom: "15px", color: "#333" }}
            >
              Please enter the OTP sent to your email address.
            </p>
            <div className="otp-input-group">
              {[0, 1, 2, 3].map((i) => (
                <input
                  key={i}
                  type="text"
                  maxLength="1"
                  value={otp[i]}
                  onChange={(e) => {
                    const val = e.target.value.replace(/[^0-9]/g, "");
                    if (val.length <= 1) {
                      const newOtp = [...otp];
                      newOtp[i] = val;
                      setOtp(newOtp);
                      if (val && i < 3) {
                        document.getElementById(`otp-input-${i + 1}`)?.focus();
                      }
                    }
                  }}
                  id={`otp-input-${i}`}
                  style={{ imeMode: "disabled" }}
                  autoFocus={i === 0}
                  onKeyDown={(e) => {
                    if (e.key === "Backspace" && !otp[i] && i > 0) {
                      document.getElementById(`otp-input-${i - 1}`)?.focus();
                    }
                  }}
                />
              ))}
            </div>
            <div
              className=""
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingTop: "10px",
              }}
            >
              {/* <button className="next-button" style={{backgroundColor: '#6c757d', marginTop: '10px'}} onClick={handleBack}>BACK</button> */}
              <button className="next-button" onClick={handleNext}>
                VERIFY & NEXT
              </button>
            </div>
          </div>
        )}

        {step === 3 && (
          <div className="reset-password-fields">
            <div className="input-group">
              <label htmlFor="new-password">New Password *</label>
              <input
                type="password"
                id="new-password"
                placeholder="Enter new password"
                value={newPassword}
                onChange={(e) => handlePasswordChange(e.target.value)}
              />
            </div>
            <div className="input-group">
              <label htmlFor="confirm-password">Confirm New Password *</label>
              <input
                type="password"
                id="confirm-password"
                placeholder="Confirm new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              {confirmPassword && (
                <div
                  style={{
                    color: newPassword === confirmPassword ? "green" : "red",
                    fontSize: "13px",
                    marginTop: "4px",
                  }}
                >
                  {newPassword === confirmPassword
                    ? "✔ Passwords match"
                    : "✖ Passwords do not match"}
                </div>
              )}
            </div>
            {passwordError && (
              <div style={{ color: "red", marginBottom: "10px" }}>
                {passwordError}
              </div>
            )}
            <div style={{ marginBottom: "10px", color: "#555" }}>
              <strong style={{ color: "black" }}>Password Requirements:</strong>
              <ul
                style={{
                  margin: "8px 0 0 18px",
                  fontSize: "13px",
                  listStyle: "none",
                  padding: 0,
                }}
              >
                {passwordChecks.map((check, idx) => (
                  <li
                    key={idx}
                    style={{
                      color: check.valid ? "green" : "red",
                      display: "flex",
                      alignItems: "center",
                      marginBottom: 2,
                    }}
                  >
                    <span
                      style={{
                        fontWeight: check.valid ? 600 : 400,
                        marginRight: 6,
                      }}
                    >
                      {check.valid ? "✔" : "✖"}
                    </span>
                    {check.label}
                  </li>
                ))}
              </ul>
            </div>
            <button
              className="next-button"
              onClick={(e) => resetPasswords(e)}
              disabled={loading}
            >
              RESET PASSWORD
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PasswordReset;
